import React from "react"
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ActivityIndicator,
  Dimensions
} from "react-native"
import Modal from "modal-enhanced-react-native-web"

interface Props {
  visible: boolean
  heading?: string
  subheading?: string
  yesText?: string
  noText?: string
  loading?: boolean
  onYes: () => void
  onNo: () => void
}

const CommonModal: React.FC<Props> = ({
  visible,
  heading = "Are you sure?",
  subheading = "",
  yesText = "Yes",
  noText = "Cancel",
  loading = false,
  onYes,
  onNo
}) => {

  const isMobile = Dimensions.get("window").width < 768

  return (
    <Modal
      isVisible={visible}
      onBackdropPress={onNo}
      animationIn="zoomIn"
      animationOut="zoomOut"
      backdropOpacity={0.4}
    >
      <View style={[styles.container, isMobile && { width: "95%" }]}>

        {/* Heading */}
        <Text style={styles.heading}>{heading}</Text>

        {/* Subheading */}
        {subheading ? (
          <Text style={styles.subheading}>{subheading}</Text>
        ) : null}

        {/* Buttons */}
        <View style={styles.buttonRow}>

         {noText? <TouchableOpacity
            style={[styles.button, styles.cancelButton]}
            onPress={onNo}
            disabled={loading}
          >
            <Text style={styles.cancelText}>{noText}</Text>
          </TouchableOpacity>:null}

         {yesText? <TouchableOpacity
            style={[styles.button, styles.confirmButton]}
            onPress={onYes}
            disabled={loading}
          >
            {loading ? (
              <ActivityIndicator color="#fff" />
            ) : (
              <Text style={styles.confirmText}>{yesText}</Text>
            )}
          </TouchableOpacity>:null}

        </View>

      </View>
    </Modal>
  )
}

export default CommonModal

/* ================= STYLES ================= */

const styles = StyleSheet.create({

  container: {
    width: 400,
    backgroundColor: "#fff",
    borderRadius: 20,
    padding: 24,
    alignSelf: "center",
  },

  heading: {
    fontSize: 18,
    fontWeight: "700",
    color: "#111827",
    textAlign: "center",
  },

  subheading: {
    fontSize: 14,
    color: "#6B7280",
    marginTop: 10,
    textAlign: "center",
    lineHeight: 20,
  },

  buttonRow: {
    flexDirection: "row",
    marginTop: 24,
    gap: 12,
  },

  button: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 30,
    alignItems: "center",
  },

  cancelButton: {
    backgroundColor: "#F3F4F6",
  },

  confirmButton: {
    backgroundColor:'rgb(160, 112, 196)',
  },

  cancelText: {
    fontSize: 14,
    fontWeight: "600",
    color: "#374151",
  },

  confirmText: {
    fontSize: 14,
    fontWeight: "600",
    color: "#fff",
  },

})
